module.exports = __webpack_public_path__ + "img/5_71.bdd9e1f2.png";